import { z } from 'zod';

/**
 * Pase del participante: link firmado (HMAC) hacia `/pase` o `/pase.pdf`.
 *
 * El backend genera el link con `POST /api/v1/participantes/:id/pase/upload`
 * y el admin lo usa para enviar/descargar. Ver `services/paseTokens.ts`.
 */

export const PaseFormatoSchema = z.enum(['pdf', 'html']);
export type PaseFormato = z.infer<typeof PaseFormatoSchema>;

/**
 * Input para POST /participantes/:id/pase/upload.
 * `ttlSeconds` opcional (default 7 días, rango 60 s – 90 días).
 */
export const PaseGenerarInputSchema = z.object({
  formato: PaseFormatoSchema.optional(),
  ttlSeconds: z.number().int().min(60).max(90 * 24 * 60 * 60).optional(),
});
export type PaseGenerarInput = z.infer<typeof PaseGenerarInputSchema>;

/**
 * Response de POST /participantes/:id/pase/upload: link firmado.
 */
export const PaseGenerarResponseSchema = z.object({
  url: z.string().url(),
  exp: z.number().int(),
  formato: PaseFormatoSchema,
  ttlSeconds: z.number().int(),
});
export type PaseGenerarResponse = z.infer<typeof PaseGenerarResponseSchema>;